import constants from 'constants/index'

const mountSegmentData = (segmentId) => {
  return constants.marketplace.pages.segments[segmentId]
}

export default mountSegmentData
